import {FormattedMessage} from 'react-intl'

function CreateLoading() {
  return <h1 className='fw-bolder text-dark mb-3'>
    <FormattedMessage id="MODAL.CREATE.LOADING" defaultMessage="Добавление..." />
  </h1>
}

export {CreateLoading}
